import { Observable } from 'rxjs/Observable';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpHeaders } from '@angular/common/http';

export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private localStorage: LocalStorageService,
        private sessionStorage: SessionStorageService
    ) {

    }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let token = this.localStorage.retrieve('authenticationToken') || this.sessionStorage.retrieve('authenticationToken');
        if (!!token) {
            const newHeaders: HttpHeaders = req.headers.append('Authorization', `Bearer ${token}`);
            const authorizedRequest = req.clone({headers: newHeaders});
            return next.handle(authorizedRequest);
        }

        return next.handle(req);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/blocks/http/interceptor/auth.interceptor.ts